import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';
import { Terminal } from '../shared/model/Terminal.model';
import { APIResult, WebAPIResult } from './employee.service';
import { SessionContextService } from './session-context.service';

export class TerminalData {
  Name: string = "";
  TillConnected: boolean = true;
  IPAddress: string = "";
  BranchUID: string = "";
  TillId: number = -1;
}

export class CashUpInfo {
  CashTotal: number;
  CardTotal: number;
  TerminalName: string;
  DiscrepancyReason: string;
  DiscrepancyText: string;
  Status: number;
  StartDate: Date;
  StartTime: Date;
  EndDate: Date;
  EndTime: Date;
}

@Injectable({
  providedIn: 'root'
})
export class TerminalService {

  constructor(private session: SessionContextService, private http: HttpClient) {
  }

  public DoesTerminalNeedToBeRegistered(): boolean {
    var t: Terminal = this.session.GetTerminal(this.session.ctx.TerminalIP, this.session.ctx.BranchId);
    if (t)
      return false;
    else
      return true;
  }

  public GetTerminal(tip: string, branchUID: string): Observable<Terminal> {
    return this.http.get<Terminal>(`/api/terminals/GetTerminal?bUID=${branchUID}&tIP=${tip}`);
  }

  public RegisterTerminal(newTerminal: TerminalData): Observable<Terminal> {
    return this.http.post<Terminal>('/api/terminals/RegisterTerminal', newTerminal).pipe(
      take(1),
      tap((terminal) => {
        console.log('Adding new terminal to default data ', terminal);
        var x = this.session.defaultData.defData.Terminals.push(terminal);
        this.session.selectTerminal(terminal.Id);
      })
    );
  }

  public DoesTerminalHaveTill(): boolean {
    return this.session.GetSelectedTerminal().TillConnected;
  }

  public IsTerminalOpen(): Observable<boolean> {

    var data = {
      BranchId: this.session.GetSelectedBranch().BranchId,
      TerminalId: this.session.GetSelectedTerminal().Id,
      CashFloat: -1.0
    };
    return this.http.post<boolean>('/api/terminals/IsTerminalOpen', data);
  }

  public OpenTerminal(cashFloat: number): Observable<boolean> {
    var data = {
      BranchId: this.session.GetSelectedBranch().BranchId,
      TerminalId: this.session.GetSelectedTerminal().Id,
      CashFloat: cashFloat,
    }
    return this.http.post<boolean>('/api/terminals/OpenTerminal', data);
  }

  public CloseTerminal(t: Terminal, cashUpInfo: CashUpInfo): Observable<CashUpInfo> {
    var data = {
      BranchId: this.session.ctx.BranchId,
      TerminalId: this.session.ctx.TerminalId,
      EmployeeId: this.session.ctx.EmployeeId,
      CashTotal: cashUpInfo.CashTotal,
      CardTotal: cashUpInfo.CardTotal,
      DiscrepancyReason: cashUpInfo.DiscrepancyReason,
      StartDate: cashUpInfo.StartDate,
      EndDate: cashUpInfo.EndDate,
      StartTime: cashUpInfo.StartTime,
      EndTime: cashUpInfo.EndTime,
    };
    return this.http.post<CashUpInfo>('/api/terminals/CloseTerminal', data);
  }

  CreateOrUpdateTerminal(s: Terminal): Observable<APIResult> {
    var data = {
      TerminalId: s.Id,
      IPAddress: s.IPAddress,
      Active: s.Active,
      Branch: s.Branch,
      Name: s.Name,
      NetBiosName: s.NetBiosName,
      TillConnected: s.TillConnected,
      TillDrawerName: s.TillDrawerName,
      PayPointConnected: s.PayPointConnected,
      PayPoint: s.PayPoint,
    };

    return this.http.post<WebAPIResult>('/api/BackOffice/Terminal/CreateOrUpdateTerminal', data).pipe(
      take(1),
      // tap(d => {
      //     console.log(d);
      // }),
      catchError((e) => {
        var result: APIResult = new APIResult();
        result.Success = 0;
        result.Msg = e;
        return of(result);
      }),
      map((m: WebAPIResult) => {
        var result: APIResult = new APIResult();
        result.Success = m.Success;
        result.Msg = m.Msg;
        return result;
      })
    );
  }
}
